import api from "./api";
import { config } from "./config.service";

const API_URL = config.host_api;

export const getVisaExtension = async (vep_id) => {
  return api
    .get(API_URL + `visa-extension/${vep_id}`)
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};

export const visaExtensionPostdocUpload = async (data) => {
  api.post(API_URL + "visa-extension", data);
};

export const getVisaExtensionPostdoc = async (vep_id) => {
  return api
    .get(API_URL + `visa-extension/${vep_id}`)
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};

export const getVisaExtensionPostdocMentor = async (mentor_id) => {
  return api
    .get(API_URL + `visa-extension/mentor/${mentor_id}`)
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};

export const getVisaExtensionPostdocAdmin = async () => {
  return api
    .get(API_URL + `visa-extension/admin`)
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};

export const updateVisaExtensionPostdoc = (vep_id, status) => {
  return api.put(`${API_URL}visa-extension/${vep_id}/${status}`);
};
